var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.user_add") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutters" },
            [_c("back-button")],
            1
          ),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("administration.user"),
                isTitleUpperCase: false,
              },
            },
            [
              _c("div", { staticClass: "form-group" }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.login"),
                          placeholderValue: _vm.$t("administration.login"),
                        },
                        model: {
                          value: _vm.login,
                          callback: function ($$v) {
                            _vm.login = $$v
                          },
                          expression: "login",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.name"),
                          placeholderValue: _vm.$t("administration.name"),
                        },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("administration.active")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.active,
                              expression: "active",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "sel4", readonly: "" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.active = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "0" } }, [
                            _vm._v(
                              " " + _vm._s(_vm.$t("administration.no")) + " "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "1" } }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("administration.in_prgrss")) +
                                " "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "2" } }, [
                            _vm._v(
                              " " + _vm._s(_vm.$t("administration.yes")) + " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", [_vm._v(_vm._s(_vm.$t("common.pwd")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex" }, [
                        _vm.passwordType === "checkbox"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password",
                                },
                              ],
                              staticClass:
                                "form-control inputAccordionForm h-30px",
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.password)
                                  ? _vm._i(_vm.password, null) > -1
                                  : _vm.password,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.password,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.password = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.password = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.password = $$c
                                  }
                                },
                              },
                            })
                          : _vm.passwordType === "radio"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password",
                                },
                              ],
                              staticClass:
                                "form-control inputAccordionForm h-30px",
                              attrs: { type: "radio" },
                              domProps: { checked: _vm._q(_vm.password, null) },
                              on: {
                                change: function ($event) {
                                  _vm.password = null
                                },
                              },
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password",
                                },
                              ],
                              staticClass:
                                "form-control inputAccordionForm h-30px",
                              attrs: { type: _vm.passwordType },
                              domProps: { value: _vm.password },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value
                                },
                              },
                            }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass:
                            "icon icon-password mt-2 pt-1 icon-field",
                          class: [
                            _vm.isPasswordFieldHidden
                              ? "fa-duotone fa-eye"
                              : "fa-duotone fa-eye-slash",
                          ],
                          on: { click: _vm.switchPasswordType },
                        }),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("administration.profile"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "label",
                        {
                          attrs: {
                            title: _vm.$t("administration.select_profile"),
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("administration.select_profile"))
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "combo-list-field d-flex justify-content-between",
                          attrs: { id: "profile-picker-link", href: "#" },
                        },
                        [
                          _c(
                            "span",
                            {
                              class:
                                "fixed-span-size " +
                                (_vm.profileDisplay.nb > 0
                                  ? "filter-item-input-complete"
                                  : ""),
                            },
                            [_vm._v(_vm._s(_vm.profileDisplay.label))]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa-light fa-chevron-down",
                            attrs: { size: "17px", id: "status-chevron" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-popover",
                        {
                          attrs: {
                            target: "profile-picker-link",
                            title: _vm.$t("administration.select_profile"),
                            triggers: "focus",
                            placement: "bottom",
                          },
                        },
                        _vm._l(_vm.profiles, function (profile, index) {
                          return _c(
                            "span",
                            {
                              key:
                                _vm.$t(
                                  "common.status.rtp." +
                                    profile.id_rights_profile
                                ) +
                                "-" +
                                index,
                            },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { value: 1, "unchecked-value": 0 },
                                  model: {
                                    value: profile.state,
                                    callback: function ($$v) {
                                      _vm.$set(profile, "state", $$v)
                                    },
                                    expression: "profile.state",
                                  },
                                },
                                [_c("span", [_vm._v(_vm._s(profile.libelle))])]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass:
                "accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters",
            },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createUser()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }